module.exports = __webpack_public_path__ + "static/media/model-shogun-sport-96.5613bee3.jpg";